<template>
  <div class="app-belatedporting-success">
    <slot v-if="this.sim === 'E_SIM'" name="ceBelatedESim"></slot>
    <slot v-else name="ceBelatedSim"></slot>
  </div>
</template>

<script>
import { checkoutTracking } from '@/helper/checkoutTracking'

export default {
  name: 'BelatedPortingSuccess',
  data () {
    return {
      sim: null
    }
  },
  mounted () {
    if (this.$store.getters['checkoutv2/belatedPorting/confirmResult'].contractId !== '') {
      this.sim = this.simType
      checkoutTracking('belatedPorting', this.$store, 'success', 3)
      this.$store.dispatch('checkoutv2/belatedPorting/resetState')
    } else {
      window.location = '/mein-simon/uebersicht'
    }
  },
  computed: {
    simType () {
      return this.$store.getters['checkoutv2/belatedPorting/_simData/simType']
    },
    mnpData: function () {
      return {
        active: this.active,
        provider: this.provider,
        contract: this.contract
      }
    }
  }
}
</script>
